<template>
  <section>
    <main class="main" :class="{ 'expand-main': isMenuCollapse }">
      <AgencyImportExcludeDomains
        :clientId="user.client_id"
        @processFinished="processFinished()"
      />
    <LoadingSpinner v-if="loadingBlacklist"></LoadingSpinner>
    <div class="p-3" v-else>
      <!-- Componente para realizar proceso de extracion de blacklist desde archivo csv -->
      
      <div class="card p-2"  v-if="total > 0">

        <div class="row p-0 m-0 align-items-center">

          <!-- Total de palabra encontradas para blacklist -->
          <div class="col-10 m-0 px-1 justify-content-start">
            <h6 class="d-inline">{{$t('lang.column.total')}}: {{total}}</h6>
          
            <!-- Button to download csv -->
            <button class="ml-4 btn btn-sm btn-primary" 
              @click="getToDownload()"
              :disabled="!processingAllItems"
              >
              <span v-if="processingAllItems">
                Download csv
              </span>
              <span v-else>Processing...</span>
            </button>
          </div>

         

          <!-- Boton borrar Blacklist completa -->
          <div class="col-6 px-1 m-0 d-flex justify-content-end">
            <button class="btn btn-sm btn-secondary" @click="removeAllBlacklist()">
              Remove Blacklist
            </button>
          </div>

        </div>

        <!-- Renderizo lista de palabras de blacklist -->
	      <div class="mt-2 p-2">
	      	<small
            v-for="(word, i) in words"
            :key="i"
            class="mr-2 badge badge-primary">
            {{word}}
          </small>

	      	<strong v-if="left > 0" class="mr-2 badge">{{$t('lang.ondemand.andmore',{cant:(left)})}} </strong>

          <span
            v-if="left > 0"
            @click="seemore()"
            class="badge badge-success text-white mt-1 cursor-pointer p-2">
              <i class="icon-plus"></i>
              {{ $t('lang.notification.seemore') }}
          </span>

	      </div>
        <button @click="deleteWords()" class="btn btn-danger mt-2" v-if="total > 0 && false">{{$t('lang.notification.delete')}}</button>
  	  </div>

      <div v-else>
        <Empty
          :loading="loadingBlacklist"
          :condition="total == 0"
        />
      </div>
    </div>
    </main>
  </section>
</template>
<script>
import { mapState } from "vuex";
import { clientsService } from "@/_services";
import AgencyImportExcludeDomains from "@/components/Agencies/AgencyImportExcludeDomains.vue";
import LoadingSpinner from '../LoadingSpinner.vue';
import Empty from "@/components/Common/Empty.vue";

export default {
    data() {
    return {
      processingAllItems:true,
      blackListComplete: [],
      words:[],
      page:0,
      total:0,
      left:0,
      loadingBlacklist: true,
    };
  },

  props: {
    clientId: {
      type: Number,
      default: null,
    },
  },

  components: {
    AgencyImportExcludeDomains,
    LoadingSpinner,
    Empty
  },

  computed: {
    ...mapState({
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),
    user() {
      return this.$store.state.authentication.user;
    },
  },

  created(){
		if(this.clientId != null){
		  clientsService.getBlacklistTotal(this.clientId).then((result) => {
			this.total = result.total
		  })
		}
		this.seemore()
	},

  methods:{
    removeAllBlacklist(){
      this.$swal({
          type: "warning",
          title: this.$t("lang.notification.delete_all"),
          text: this.$t("lang.notification.delete_all_subtitle"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t('lang.notification.delete'),
         }).then((result) => {

          if (result.value) {
            clientsService.deleteAllBlacklist(this.clientId !== null ? this.clientId : undefined)
            .then(res => {
              this.loadingBlacklist = false;
              this.total = 0;
              this.$swal({
                type: "success",
                title: "Done!",
                text: "",
                showCancelButton: false,
              })
            })
            .catch( err => {
                console.log(err)
                this.$swal({
                type: "error",
                title: "Error",
                text: "",
                showCancelButton: false,
              })
              });
          }

        })

    },

    processFinished(){
      setTimeout(() => {
       this.seemore()
      }, 1000);
    },

    seemore(allItems = 0){
      if(allItems == 0) {
        this.loadingBlacklist = true;
      } else {
        this.processingAllItems = false
      }
      clientsService.getBlacklist(this.page, this.clientId !== null ? this.clientId : undefined, allItems).then((result) => {
        if(allItems){
          this.blackListComplete  = result.words.map( el => el.word)
          this.download();
        } else {

          if(result.words){
          result.words.forEach((res) => {
            this.words.push(res)
          })
          this.total = result.total
          this.left = result.left
          this.page++
        }
        this.loadingBlacklist = false
        }
        
      });

    },
    getToDownload() {
        const allItems = 1; // cuando quieres pedir todos los resultados sin limite
        this.seemore(allItems)
    },
    download() {   

        const nameDocument = "report-black-list.csv";

        //Tomo headers desde simpleheader
        const headers = ["Black-list"] //this.headers.map(h => h.label);

        const fields = this.blackListComplete

        const csv = `${headers.join(",")}\n${fields.join("\n")}`;
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", nameDocument);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.processingAllItems = true
    },
  	deleteWords(){
      this.$swal({
          type: "warning",
          title: this.$t("lang.refuse.sure"),
          text: "",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t('lang.notification.delete'),
        }).then((result) => {
          if (result.value) {
            clientsService.deleteWords();
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.label.passwordchangedsuccessfully"),
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
    }
  }

}
</script>
